export default __webpack_public_path__ + "static/media/warning-white.f0aec827.svg";